var render, staticRenderFns
import script from "./listOfChargesList.vue?vue&type=script&lang=js&"
export * from "./listOfChargesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c761d4",
  null
  
)

export default component.exports